export const MARKETING_ROUTES = {
	home: {
		en: '/',
		fr: '/fr',
	},
	compare: {
		en: '/compare',
		fr: '/fr/comparaison',
	},
	alternatives: {
		en: '/alternatives',
		fr: '/fr/alternatives',
	},
	categoriesFeatures: {
		en: '/categories/features',
		fr: '/fr/categories/fonctionnalites',
	},
	websiteFeedbackWidget: {
		en: '/product/website-feedback-widget',
		fr: '/fr/produit/widget-feedback-site-web',
	},
	inAppFeedbackWidget: {
		en: '/product/in-app-feedback-widget',
		fr: '/fr/produit/widget-feedback-in-app',
	},
	featureVotingTool: {
		en: '/product/feature-voting-tool',
		fr: '/fr/produit/outil-vote-fonctionnalites',
	},
	publicRoadmapSoftware: {
		en: '/product/public-roadmap-software',
		fr: '/fr/produit/logiciel-roadmap-publique',
	},
	testimonialsWidget: {
		en: '/product/testimonials-widget',
		fr: '/fr/produit/widget-temoignages-clients',
	},
	bugReportWidget: {
		en: '/product/bug-report-widget',
		fr: '/fr/produit/widget-signalement-bug',
	},
} as const

export type MarketingRouteKey = keyof typeof MARKETING_ROUTES

export function getLocalizedRoute(key: MarketingRouteKey, isFrench: boolean) {
	return isFrench ? MARKETING_ROUTES[key].fr : MARKETING_ROUTES[key].en
}
